import { Injectable } from '@angular/core';
import { SelectInputsList } from '@portal/shared/helpers/src';
import { ISelectInput } from '@portal/shared/ui/filter';
import { sortBy } from 'lodash';
import { TransactionReportType } from '../enum/transaction-report-type.enum';

declare const $localize;
@Injectable()
export class TransactionReportTypes extends SelectInputsList {
  keyValue = {
    [TransactionReportType.Basic]: $localize`:transaction report type|:Transaction report - Basic (new)`,
    [TransactionReportType.Full]: $localize`:transaction report type|:Transaction report - Full (new)`,
    [TransactionReportType.BasicPDSP]: $localize`:transaction report type|:Transaction report - Basic (old format)`,
    [TransactionReportType.FullPDSP]: $localize`:transaction report type|:Transaction report - Full (old format)`,
    [TransactionReportType.Custom]: $localize`:transaction report type|:Transaction report - Custom`,
  };
  list: ISelectInput[] = sortBy(this.getSelectInputs(), ['text']);

  constructor() {
    super();
  }
}
